import { defineMessages } from 'react-intl'

const translations = defineMessages({
  returnOrder: {
    defaultMessage: 'Return Order',
    id: 'msp.account.order_history.order_detail.action.return_order'
  },
  orderReturnTitle: {
    defaultMessage: 'Returns',
    id: 'msp.account.order_history.order_detail.order_return.title'
  },
  orderReturnDescriptionTitle: {
    defaultMessage: 'Confirmation of your return',
    id: 'msp.account.order_history.order_detail.order_return.description_title'
  },
  orderReturnDescriptionContent: {
    defaultMessage:
      'You can download and print out the documents required for the return shipment below. Please fill the document by selecting the product(s) you wish to return.',
    id: 'msp.account.order_history.order_detail.order_return.description_content'
  },
  orderReturnDownload: {
    defaultMessage: 'Download',
    id: 'msp.account.order_history.order_detail.order_return.download'
  },
  orderReturnClose: {
    defaultMessage: 'Close',
    id: 'msp.account.order_history.order_detail.order_return.close'
  },
  orderReturnLabel: {
    defaultMessage: 'Return Slip & Label',
    id: 'msp.account.order_history.order_detail.order_return.slip_label'
  }
})

export default translations
